// «Ещё» и настройки: типы сессий, график, правила отмены, встречи и адреса, «Мой налог», вид, валюты, напоминания,
// резервная копия, журнал. Календарь и выписки — заглушки до их шагов.
import { COLOR_DEFAULTS, MEET, MEET_LABEL, RU_DAYS, RU_DAYS_FULL, colorLabel, fillTemplate, hasValue, hmToMin, isColor,
  isCommercial, minToHm, money, ruDateShort, ruleLabel, tzCity, wallClock, type MeetKind, type TypeOut,
  type WeekDayOut } from '@praktika/core';
import { afterChange, call, reload, rpc, saveSettings } from '../lib/api.ts';
import { BG_DARK, BG_LIGHT, bgv, colName, colorSheet, colv } from '../lib/colors.ts';
import { $, $$, esc, toast } from '../lib/dom.ts';
import { activeTypes, groupById } from '../lib/data.ts';
import { SCREENS, current, render, title } from '../lib/nav.ts';
import { chooseSheet, closeSheet, curOptions, curSheet, kvBtn, kvTog, openSheet, opt, promptSheet } from '../lib/sheet.ts';
import { S } from '../lib/state.ts';
import { themeLabel } from '../lib/theme.ts';
import { logout } from '../lib/login.ts';
import { extraZones, tzDiffLabel, tzSheet } from '../lib/zones.ts';
import { bindCommon } from './common.ts';
import { chooseRule } from './parts.ts';

// сколько истории держать в приложении: все сессии или за срок (быстрее на старом телефоне при больших архивах)
const BACK: Array<[number, string, string]> = [[0, 'Все', 'вся история с первой сессии'],
  [365, 'За последний год', ''], [182, 'За полгода', ''], [91, 'За 3 месяца', '']];
const backLabel = (v: number) => (BACK.find((x) => x[0] === (v || 0)) ?? BACK[0]!)[1].toLowerCase();

// «пн–пт 10–19, сб 11–15»
function weekSummaryTxt(): string {
  const parts: string[] = [], hrs = (t: string) => { const x = hmToMin(t) ?? 0; return x % 60 ? minToHm(x) : String(x / 60); };
  let i = 0;
  while (i < 7) {
    const w = S.week[i];
    if (!w || !w.on) { i++; continue; }
    let j = i;
    while (j + 1 < 7 && S.week[j + 1]!.on && S.week[j + 1]!.start === w.start && S.week[j + 1]!.end === w.end) j++;
    parts.push((j > i ? RU_DAYS[i]!.toLowerCase() + '–' + RU_DAYS[j]!.toLowerCase() : RU_DAYS[i]!.toLowerCase()) + ' ' +
      hrs(w.start) + '–' + hrs(w.end));
    i = j + 1;
  }
  return parts.join(', ') || 'не задан';
}

SCREENS.more = (app) => {
  const s = S.settings;
  app.innerHTML = title('Ещё', '', true) +
    '<div class="card"><button class="kv act" data-go="import"><span class="k">Загрузить выписку</span>' +
      '<span class="v chev"></span></button><button class="kv act" data-go="calendar"><span class="k">Календарь Google</span>' +
      '<span class="v chev small">' + esc(S.calendar.connected ? (S.calendar.lastSync ? 'синхронизирован ' +
      S.calendar.lastSync : 'подключён') : 'не подключён') + '</span></button></div>' +
    '<div class="card"><div class="hd">Настройки</div>' + kvBtn('Типы сессий', activeTypes().length + '',
      'data-go="setTypes"') + kvBtn('График работы', weekSummaryTxt(), 'data-go="setWeek"') + kvBtn('Правила отмены',
      s.rule_hours + ' ч · ' + ruleLabel(s.rule_late, '') + ' · ' + ruleLabel(s.rule_noshow, ''), 'data-go="setRules"') +
    kvBtn('Ссылки и встречи', MEET_LABEL[s.meet_kind_default] || '', 'data-go="setLinks"') +
      kvBtn('Мой налог', 'источники не отмечены', 'data-go="setTax"') +
    kvBtn('Внешний вид', themeLabel(s.theme || 'system') + ' · цвета', 'data-go="appearance"') +
      kvBtn('Как к вам обращаться', s.user_name || 'не задано', 'data-uname') +
      kvBtn('Валюты', s.main_currency + ', вторая ' + s.second_currency, 'data-go="setCur"') +
      kvBtn('Напоминания клиентам', 'текст', 'data-go="setReminders"') +
      kvBtn('Сессии в приложении', backLabel(s.sessions_back), 'data-sback') +
      kvBtn('Резервная копия', 'каждую ночь', 'data-go="setBackup"') + '</div>' +
    '<div class="card">' + (S.admin ? '<button class="kv act" data-go="practices"><span class="k">Кабинеты</span>' +
      '<span class="v chev small">кто в них входит</span></button>' : '') +
      '<button class="kv act" data-go="log"><span class="k">Журнал действий</span>' +
      '<span class="v chev"></span></button>' + (S.email ? '<button class="kv act" data-logout><span class="k">' +
      'Выйти из аккаунта</span><span class="v chev small">' + esc(S.email) + '</span></button>' : '') + '</div>' +
    '<p class="p-note">Практика · версия ' + esc(S.version) + ' · ' + esc(tzCity(S.tz)) + (S.email ? ' · ' +
      esc(S.email) : '') + '</p>';
  bindCommon(app);
  $('[data-sback]', app).onclick = () => chooseSheet('Сессии в приложении', BACK.map(([value, label, hint]) =>
    ({ value, label, hint })), s.sessions_back || 0, (v) => { void saveSettings({ sessions_back: v }, 'Готово'); });
  const lo = $('[data-logout]', app);
  if (lo) lo.onclick = () => {
    const sh = openSheet('<div class="ttl">Выйти из аккаунта</div><p class="sub">' + esc(S.email) +
      '. Данные остаются на сервере, при следующем входе всё будет на месте.</p>' + opt('', '', 'Выйти'));
    $('button.opt', sh).onclick = () => { closeSheet(); void logout(); };
  };
};

// Внешний вид: тема, фон приложения, цвета клиентов по умолчанию и у групп.
SCREENS.appearance = (app) => {
  const s = S.settings, cp = isColor(s.color_personal) ? s.color_personal : COLOR_DEFAULTS.personal,
    cpr = isColor(s.color_project) ? s.color_project : COLOR_DEFAULTS.project;
  app.innerHTML = title('Внешний вид') +
    '<div class="card"><div class="hd">Тема и фон</div><button class="kv" data-theme-pick><span class="k">Тема</span>' +
      '<span class="v chev">' + esc(themeLabel(s.theme || 'system')) + '</span></button>' +
    '<button class="kv" data-bg="light"><span class="k">Фон в светлой теме</span><span class="v chev">' +
      bgv(BG_LIGHT, s.bg_light, false) + '</span></button><button class="kv" data-bg="dark"><span class="k">Фон в тёмной ' +
      'теме</span><span class="v chev">' + bgv(BG_DARK, s.bg_dark, true) + '</span></button></div>' +
    '<div class="card"><div class="hd">Цвета клиентов по умолчанию</div><button class="kv" data-cd="color_personal">' +
      '<span class="k">Личные группы</span><span class="v chev">' + colv(cp) + '</span></button>' +
      '<button class="kv" data-cd="color_project"><span class="k">Коммерческие проекты</span><span class="v chev">' +
      colv(cpr) + '</span></button></div>' +
    (S.groups.length ? '<div class="card"><div class="hd">Свой цвет у группы</div>' + S.groups.map((g) =>
      '<button class="kv" data-pc="' + esc(g.id) + '"><span class="k">' + esc(g.name) + '</span><span class="v chev">' +
      (isColor(g.color) ? colv(g.color) : 'как у всех') + '</span></button>').join('') + '</div>' : '') +
    '<p class="p-note">Свой цвет клиента (в его карточке) главнее цвета группы, а тот главнее цвета по умолчанию. ' +
    'В календарь Google цвет ставится событиям, которые приложение создаёт или обновляет само.</p>';
  bindCommon(app);
  $$('[data-bg]', app).forEach((b) => {
    b.onclick = () => {
      const dark = b.getAttribute('data-bg') === 'dark', key = dark ? 'bg_dark' : 'bg_light';
      colorSheet({ title: dark ? 'Фон в тёмной теме' : 'Фон в светлой теме', current: s[key] || '',
        kind: dark ? 'bgdark' : 'bglight', none: 'Как обычно' }, (v) => void saveSettings({ [key]: v }));
    };
  });
  $$('[data-cd]', app).forEach((b) => {
    b.onclick = () => {
      const key = b.getAttribute('data-cd') === 'color_project' ? 'color_project' : 'color_personal',
        def = COLOR_DEFAULTS[key === 'color_project' ? 'project' : 'personal'];
      colorSheet({ title: key === 'color_project' ? 'Цвет коммерческих проектов' : 'Цвет личных групп',
        sub: 'Для всех, у кого нет своего цвета.', current: isColor(s[key]) ? s[key] : def, kind: 'client',
        none: 'Как было изначально', noneHint: colorLabel(def).toLowerCase() }, (v) => void saveSettings({ [key]: v || def }));
    };
  });
  $$('[data-pc]', app).forEach((b) => {
    b.onclick = () => {
      const g = groupById(b.getAttribute('data-pc'));
      if (!g) return;
      colorSheet({ title: 'Цвет клиентов «' + g.name + '»', current: g.color || '', kind: 'client', none: 'Как у всех',
        noneHint: colName(isCommercial(g) ? cpr : cp).toLowerCase() }, (v) => void call('saveGroup', { id: g.id, color: v })
        .then(() => afterChange('Сохранено'), () => {}));
    };
  });
};

SCREENS.setTypes = (app) => {
  app.innerHTML = title('Типы сессий') +
    '<div class="p-sum">Сколько угодно типов. Один по умолчанию: он подставляется новым клиентам. Цена типа берётся, ' +
    'когда у личного клиента своя цена не указана.</div><div class="card">' + activeTypes().map((t) =>
      '<button class="kv" data-type="' + esc(t.id) + '"><div><div class="v" style="text-align:left">' + esc(t.name) +
      '</div><div class="k" style="font-size:12px">' + t.dur + ' мин · перерыв после ' + t.brk + (hasValue(t.price) ?
      ' · ' + esc(money(t.price, t.cur || S.settings.main_currency)) : ' · цена не задана') + '</div></div>' +
      (t.isDefault ? '<span class="bal zero">по умолчанию</span>' : '<span class="v chev"></span>') + '</button>').join('') +
    '</div><div class="btnrow"><button class="btn sec" data-add>+ Добавить тип</button></div><div class="card">' +
    kvBtn('Перерыв для новых типов', S.settings.type_break_default + ' мин', 'data-brk') + '</div>';
  $$('[data-type]', app).forEach((b) => {
    b.onclick = () => { const t = S.types.find((x) => x.id === b.getAttribute('data-type')); if (t) typeSheet(t); };
  });
  $('[data-add]', app).onclick = () => typeSheet({ id: '', name: '', dur: 50, brk: Number(S.settings.type_break_default) || 15,
    isDefault: false, active: true, price: null, cur: null });
  $('[data-brk]', app).onclick = () => promptSheet('Перерыв для новых типов, мин', S.settings.type_break_default, 'number',
    (v) => void saveSettings({ type_break_default: Number(v) || 0 }));
};

function typeSheet(t: TypeOut): void {
  const st = { id: t.id, name: t.name, dur: t.dur, brk: t.brk, isDefault: t.isDefault, price: t.price,
    cur: t.cur || S.settings.main_currency };
  const draw = () => {
    const sh = openSheet('<div class="ttl">' + (st.id ? esc(st.name) : 'Новый тип') + '</div><p class="sub">Тип сессии</p>' +
      '<div class="kv"><span class="k">Название</span><input data-name value="' + esc(st.name) +
      '" placeholder="например, Пара" style="flex:1;text-align:right;border:0;outline:0;font-weight:500"></div>' +
      '<div class="kv"><span class="k">Длительность</span><span class="stp"><button data-d="-5">−</button><b>' + st.dur +
      ' мин</b><button data-d="5">+</button></span></div><div class="kv"><span class="k">Перерыв после</span>' +
      '<span class="stp"><button data-b="-5">−</button><b>' + st.brk + ' мин</b><button data-b="5">+</button></span></div>' +
      '<button class="kv" data-tprice><span class="k">Цена по умолчанию</span><span class="v chev">' +
      (hasValue(st.price) ? esc(money(st.price, st.cur)) : 'не задана') + '</span></button>' +
      '<button class="kv" data-def><span class="k">По умолчанию</span><span class="tog' + (st.isDefault ? ' on' : '') +
      '"></span></button><div class="btnrow" style="padding:12px 0 0"><button class="btn pri" data-save>Сохранить</button>' +
      (st.id ? '<button class="btn txt" style="flex:0 0 auto" data-del>Удалить</button>' : '') + '</div>');
    const nm = $<HTMLInputElement>('[data-name]', sh);
    nm.oninput = () => { st.name = nm.value; };
    $$('[data-d]', sh).forEach((b) => { b.onclick = () => { st.dur = Math.max(5, st.dur + Number(b.getAttribute('data-d'))); draw(); }; });
    $$('[data-b]', sh).forEach((b) => { b.onclick = () => { st.brk = Math.max(0, st.brk + Number(b.getAttribute('data-b'))); draw(); }; });
    $('[data-def]', sh).onclick = () => { st.isDefault = !st.isDefault; draw(); };
    $('[data-tprice]', sh).onclick = () => {
      st.name = nm.value;
      promptSheet('Цена по умолчанию', st.price, 'number', (v) => {
        if (v === '') { st.price = null; draw(); return; }
        st.price = Number(v);
        curSheet('Валюта', st.cur, (cu) => { st.cur = cu; draw(); });
      }, 'Берётся для личного клиента, у которого своя цена не указана. Пусто — без цены.');
    };
    $('[data-save]', sh).onclick = () => {
      if (!st.name.trim()) { toast('Введите название', true); return; }
      closeSheet();
      void call('saveType', { ...st, id: st.id || undefined }).then(() => afterChange('Сохранено'), () => {});
    };
    const d = $('[data-del]', sh);
    if (d) d.onclick = () => {
      if (!confirm('Удалить тип «' + st.name + '»?')) return;
      closeSheet();
      void call<{ archived: boolean }>('deleteType', st.id).then((r) => afterChange(r.archived ?
        'Тип скрыт: он используется у клиентов' : 'Удалено'), () => {});
    };
  };
  draw();
}

SCREENS.setWeek = (app) => {
  app.innerHTML = title('График работы') +
    '<div class="p-sum">Нажмите на день, чтобы изменить часы и обед. Выходные и обед видны в расписании.</div><div class="card">' +
    S.week.map((w, i) => '<div class="kv"><span class="lft' + (!w.on ? ' small' : '') + '">' + esc(w.day) +
      '</span><button class="mid' + (!w.on ? ' small' : '') + '" data-edit="' + i + '" style="text-align:left">' +
      (w.on ? esc(w.start + '–' + w.end) + ((hmToMin(w.lunchStart) ?? -1) >= 0 &&
      (hmToMin(w.lunchEnd) ?? -1) > (hmToMin(w.lunchStart) ?? -1) ? ' · обед ' + esc(w.lunchStart + '–' + w.lunchEnd) :
      ' · без обеда') : 'выходной') + '</button><button class="tog' + (w.on ? ' on' : '') + '" data-tog="' + i +
      '"></button></div>').join('') + '</div>' +
    '<div class="card">' + kvBtn('Шаг времени при записи', S.settings.step + ' мин', 'data-step') +
      kvBtn('Часовой пояс психолога', tzCity(S.tz), 'data-tz') + '</div>' +
    '<div class="card"><div class="hd">Пояса на шкале дня</div>' + extraZones().map((z) => kvBtn(tzCity(z),
      tzDiffLabel(z), 'data-exz="' + esc(z) + '"')).join('') + '<button class="kv act" data-exadd><span class="k">' +
      '+ Добавить пояс</span><span class="v chev small">колонка времени рядом с вашей</span></button></div>' +
    '<p class="p-note">Пояс клиента задаётся в его карточке: при записи время показывается и по-вашему, и по-его.</p>';
  const saveWeek = (d: WeekDayOut) => {
    const prev = S.week.map((w) => ({ ...w }));
    S.week[d.dow] = d;
    render();
    rpc('saveWeek', [{ dow: d.dow, on: d.on, start: d.start, end: d.end, lunchStart: d.lunchStart, lunchEnd: d.lunchEnd }])
      .then(() => { toast('График сохранён'); return reload(); }, (e: Error) => { S.week = prev; render(); toast(e.message, true); });
  };
  $$('[data-tog]', app).forEach((b) => {
    b.onclick = () => {
      const w = S.week[Number(b.getAttribute('data-tog'))]!;
      saveWeek({ ...w, on: !w.on, start: w.start || '10:00', end: w.end || '19:00' });
    };
  });
  $$('[data-edit]', app).forEach((b) => {
    b.onclick = () => {
      const i = Number(b.getAttribute('data-edit')), w = S.week[i]!;
      const field = (l: string, attr: string, v: string, mb = 8) => '<div class="field" style="margin:0 0 ' + mb +
        'px;flex:1"><div class="l">' + l + '</div><input type="time" ' + attr + ' value="' + esc(v) + '"></div>';
      const sh = openSheet('<div class="ttl">' + esc(RU_DAYS_FULL[i]) + '</div><p class="sub">Рабочие часы и обед</p>' +
        '<div style="display:flex;gap:8px">' + field('Начало', 'data-s', w.start || '10:00') + field('Конец', 'data-e',
        w.end || '19:00') + '</div><div style="display:flex;gap:8px">' + field('Обед с', 'data-ls', w.lunchStart || '') +
        field('Обед до', 'data-le', w.lunchEnd || '') + '</div><p class="sub">Оставьте обед пустым, если его нет.</p>' +
        '<div class="btnrow" style="padding:0"><button class="btn pri" data-ok>Сохранить</button></div>');
      $('[data-ok]', sh).onclick = () => {
        const v = (a: string) => $<HTMLInputElement>(a, sh).value;
        const d = { ...w, on: true, start: v('[data-s]'), end: v('[data-e]'), lunchStart: v('[data-ls]'), lunchEnd: v('[data-le]') };
        if ((hmToMin(d.end) ?? 0) <= (hmToMin(d.start) ?? 0)) { toast('Конец раньше начала', true); return; }
        closeSheet();
        saveWeek(d);
      };
    };
  });
  $('[data-step]', app).onclick = () => chooseSheet('Шаг времени', [5, 10, 15, 30].map((v) => ({ value: v,
    label: v + ' минут' })), S.settings.step, (v) => void saveSettings({ step: v }));
  $('[data-tz]', app).onclick = () => tzSheet(S.tz, (v) => void saveSettings({ tz: v }, 'Пояс изменён'));
  $$('[data-exz]', app).forEach((b) => {
    b.onclick = () => {
      const z = b.getAttribute('data-exz')!;
      chooseSheet(tzCity(z), [{ value: 'keep', label: 'Оставить на шкале' }, { value: 'del', label: 'Убрать со шкалы' }],
        'keep', (v) => { if (v === 'del') void saveSettings({ tz_extra: extraZones().filter((x) => x !== z).join(';') }, 'Пояс убран'); });
    };
  });
  $('[data-exadd]', app).onclick = () => tzSheet('', (v) => {
    if (v === S.tz || extraZones().includes(v)) { toast('Этот пояс уже на шкале'); return; }
    void saveSettings({ tz_extra: extraZones().concat([v]).join(';') }, 'Пояс добавлен');
  });
};

SCREENS.setRules = (app) => {
  const s = S.settings;
  app.innerHTML = title('Правила отмены') +
    '<div class="p-sum">Значения по умолчанию. Они показываются в карточке каждого клиента, там их можно поправить. ' +
    'У проекта свои правила в его карточке.</div><div class="card">' +
    kvBtn('Отмена «вовремя», если раньше чем за', s.rule_hours + ' ч', 'data-k="rule_hours"') +
    kvBtn('Отмена поздно, оплачивается', ruleLabel(s.rule_late, s.main_currency), 'data-r="rule_late"') +
    kvBtn('Не пришёл, оплачивается', ruleLabel(s.rule_noshow, s.main_currency), 'data-r="rule_noshow"') +
    kvBtn('Отменил психолог', ruleLabel(s.rule_psy, s.main_currency), 'data-r="rule_psy"') + '</div>' +
    '<div class="card">' + kvTog('Ставить «вовремя» или «поздно» самому при удалении из календаря', s.rule_auto,
      'data-auto') + '</div><p class="p-note">Изменение правил не пересчитывает уже начисленное.</p>';
  $('[data-k]', app).onclick = () => promptSheet('Часов до сессии', s.rule_hours, 'number',
    (v) => void saveSettings({ rule_hours: Number(v) || 24 }));
  $$('[data-r]', app).forEach((b) => {
    b.onclick = () => {
      const k = b.getAttribute('data-r') as 'rule_late' | 'rule_noshow' | 'rule_psy';
      chooseRule($('.k', b).textContent ?? '', s[k], s.main_currency, (v) => void saveSettings({ [k]: v }));
    };
  });
  $('[data-auto]', app).onclick = () => void saveSettings({ rule_auto: !s.rule_auto });
};

const MEET_KINDS: MeetKind[] = [MEET.MEET, MEET.ZOOM, MEET.OWN_LINK, MEET.NONE, MEET.OFFLINE];

SCREENS.setLinks = (app) => {
  const s = S.settings;
  app.innerHTML = title('Ссылки и встречи') +
    '<div class="card"><div class="hd">Онлайн-сессии, по умолчанию для новых клиентов</div>' +
      kvTog('Создавать встречу Google Meet', s.meet_default, 'data-meetdef') + kvBtn('Встреча',
      MEET_LABEL[s.meet_kind_default] || '', 'data-kind') + '</div>' +
    '<div class="p-sum">Общей ссылки на всех клиентов нет: на встречу мог бы зайти другой клиент. Постоянная ссылка ' +
      'бывает только у конкретного клиента, задаётся в его карточке.</div>' +
    '<div class="card"><div class="hd">Очные встречи · адреса</div>' + S.addresses.map((a, i) => '<button class="kv" ' +
      'data-addr="' + i + '"><span class="k" style="color:var(--text)">' + esc(a) + '</span><span class="v small">изменить' +
      '</span></button>').join('') + '<button class="kv" data-addr-add><span class="k" style="color:#2563eb">' +
      '+ Добавить адрес</span></button></div>';
  $('[data-meetdef]', app).onclick = () => void saveSettings({ meet_default: !s.meet_default });
  $('[data-kind]', app).onclick = () => chooseSheet('Встреча по умолчанию', MEET_KINDS.map((k) => ({ value: k,
    label: MEET_LABEL[k] })), s.meet_kind_default, (v) => void saveSettings({ meet_kind_default: v }));
  const saveAddr = (list: string[]) => void saveSettings({ addresses: list.map((a) => a.trim()).filter(Boolean).join('; ') });
  $$('[data-addr]', app).forEach((b) => {
    b.onclick = () => {
      const i = Number(b.getAttribute('data-addr'));
      promptSheet('Адрес', S.addresses[i], 'text', (v) => { const l = S.addresses.slice(); l[i] = v; saveAddr(l); },
        'Пустая строка удалит адрес');
    };
  });
  $('[data-addr-add]', app).onclick = () => promptSheet('Новый адрес', '', 'text', (v) => { if (v) saveAddr(S.addresses.concat([v])); });
};

SCREENS.setTax = (app) => {
  const s = S.settings;
  app.innerHTML = title('Мой налог') +
    '<div class="p-sum">В чеки попадают только рублёвые оплаты с отмеченных источников. Остальное мимо.</div>' +
    '<div class="card">' + kvBtn('Услуга в чеке', s.receipt_service, 'data-k="receipt_service"') + kvBtn('Срок чека',
      (s.receipt_due_day || 9) + '-е число следующего месяца', 'data-k="receipt_due_day"') +
      kvBtn('Напоминать о невыбитых', 'вечером в ' + s.receipt_remind_hour + ':00', 'data-k="receipt_remind_hour"') +
      kvBtn('Налог с физлиц', s.tax_person + '%', 'data-k="tax_person"') + kvBtn('Налог с юрлиц', s.tax_org + '%',
      'data-k="tax_org"') + '</div>' +
    '<p class="p-note">Банки-источники появятся здесь после загрузки их выписок.</p>';
  $$('[data-k]', app).forEach((b) => {
    b.onclick = () => {
      const k = b.getAttribute('data-k') as 'receipt_service' | 'receipt_due_day' | 'receipt_remind_hour' | 'tax_person' |
        'tax_org', num = k !== 'receipt_service';
      promptSheet($('.k', b).textContent ?? '', s[k], num ? 'number' : 'text',
        (v) => void saveSettings({ [k]: num ? Number(v) : v }));
    };
  });
};

SCREENS.setCur = (app) => {
  const s = S.settings, list = curOptions();
  app.innerHTML = title('Валюты') + '<div class="card">' + kvBtn('Основная валюта итогов', s.main_currency, 'data-main') +
    kvBtn('Вторая валюта, для показа', s.second_currency, 'data-sec') + '</div><p class="p-note">Цена у каждого клиента ' +
    'в его валюте. Курс фиксируется на дату сессии и оплаты и потом не меняется.</p>';
  $('[data-main]', app).onclick = () => chooseSheet('Основная валюта', list, s.main_currency,
    (v) => void saveSettings({ main_currency: v }));
  $('[data-sec]', app).onclick = () => chooseSheet('Вторая валюта', list, s.second_currency,
    (v) => void saveSettings({ second_currency: v }));
};

const INSERTS: Array<[string, string]> = [['имя', 'Имя клиента'], ['когда', 'Когда'], ['пояс', 'Часовой пояс'],
  ['ссылка', 'Ссылка на встречу'], ['адрес', 'Адрес']];

SCREENS.setReminders = (app) => {
  const sample = { 'имя': 'Лена', 'когда': 'завтра в 13:00', 'пояс': 'по Москве',
    'ссылка': 'https://meet.google.com/abc-defg-hij', 'адрес': 'ул. Абовяна 12' };
  app.innerHTML = title('Напоминания клиентам') +
    '<div class="p-sum">Этот текст открывается в WhatsApp или Telegram кнопкой «Написать». Кнопки ниже вставляют в текст ' +
    'имя клиента, время и остальное: приложение подставит их само для каждого клиента.</div>' +
    '<div class="field"><div class="l">Текст</div><textarea data-t rows="5">' + esc(S.settings.reminder_text) +
    '</textarea></div><div class="ins">' + INSERTS.map((x) => '<button data-ins="' + esc(x[0]) + '">+ ' + esc(x[1]) +
    '</button>').join('') + '</div><div class="preview"><span class="cap">Так увидит клиент</span><span data-pv></span></div>' +
    '<div class="btnrow"><button class="btn pri" data-save>Сохранить</button></div>';
  bindCommon(app);
  const ta = $<HTMLTextAreaElement>('[data-t]', app), pv = $('[data-pv]', app);
  const show = () => { pv.textContent = fillTemplate(ta.value, sample); };
  ta.oninput = show;
  show();
  $$('[data-ins]', app).forEach((b) => {
    b.onclick = () => {
      const ins = '{' + b.getAttribute('data-ins') + '}', a = ta.selectionStart ?? ta.value.length,
        z = ta.selectionEnd ?? ta.value.length;
      ta.value = ta.value.slice(0, a) + ins + ta.value.slice(z);
      ta.focus();
      ta.selectionStart = ta.selectionEnd = a + ins.length;
      show();
    };
  });
  $('[data-save]', app).onclick = () => void saveSettings({ reminder_text: ta.value });
};

// Копии базы делает сам сервер (на NAS — каждую ночь, хранятся последние 30).
SCREENS.setBackup = (app) => {
  app.innerHTML = title('Резервная копия') + '<div class="card"><div class="kv"><span class="k">Когда</span>' +
    '<span class="v">каждую ночь</span></div><div class="kv"><span class="k">Хранится</span><span class="v">последние 30 ' +
    'копий</span></div></div><p class="p-note">Копии всей базы кабинета делает сервер. Восстановить копию — попросить ' +
    'администратора.</p>';
};

interface LogRow { time: string; action: string; details: string }

SCREENS.log = (app) => {
  app.innerHTML = title('Журнал') + '<div class="empty">загружаю…</div>';
  rpc<LogRow[]>('log', 40).then((rows) => {
    if (current().name !== 'log') return;
    const when = (t: string) => { const w = wallClock(new Date(t), S.tz); return ruDateShort(w.date) + ' ' + w.hm; };
    app.innerHTML = title('Журнал', rows.length + '') + '<div class="card">' + rows.slice().reverse().map((r) =>
      '<div class="kv col"><span class="v">' + esc(r.action) + ' <span class="small">' + esc(when(r.time)) +
      '</span></span><span class="k small">' + esc(r.details) + '</span></div>').join('') + '</div>';
  }, (e: Error) => toast(e.message, true));
};

// Загрузка выписок банка — следующим шагом.
SCREENS.import = (app) => {
  app.innerHTML = title('Загрузить выписку') + '<div class="empty">Загрузка выписок банка появится в следующей сборке.</div>';
};
